export default {
    "查看全部x个作品": "查看全部 <i class='n'>{count}</i> 个作品",
    "x的活动": "{name}的活动",
    "x的直播": "{name}的直播",
    "作品收录于": "作品收录于",
    "x件作品被收录": "{count} 件作品被收录",
    "共x个作品": "共{count}个作品",
    "喜欢": "喜欢",
    "发布的作品": "发布的作品",
    "发布的文章": "发布的文章",
    "关注的频道": "关注的频道",
    "喜欢的作品": "喜欢的作品",
    "发布的活动": "发布的活动",
    "喜欢的文章": "喜欢的文章",
    "还没有发布的内容": "还没有发布的内容",
    "还没有发布的文章": "还没有发布的文章",
    "还没有关注": "还没有关注",
    "还没有粉丝": "还没有粉丝",
    "还没有喜欢的作品": "还没有喜欢的作品",
    "还没有喜欢的文章": "还没有喜欢的文章",
    "还没有发布的作品": "还没有发布的作品",
    "更换背景图": "更换背景图",
    "图片尺寸不小于1440*250px": "图片尺寸不小于1440*250px",
    "分享到其它平台": "分享到其它平台",
    "拖动背景以调整图片位置": "拖动背景以调整图片位置",


    "艺术/设计/科技 跨界创新": "艺术/设计/科技 跨界创新",
    "MANA公众号": "MANA公众号",
    "没有更多了": "没有更多了",
    "请": "请",
    "再发表评论": "再发表评论",
    "文章预览": "文章预览",
    "视频上传中": "视频上传中",
    "视频上传失败": "视频上传失败",

    "账户设置": "账户设置",
    "草稿已保存": "草稿已保存",
    "草稿保存中…": "草稿保存中…",
    "查看全部x条回复": "查看全部{count}条回复",
    "共x条评论": "共{count}条评论",
    "发表您的评论…": "发表您的评论…",
    "还没有评论": "还没有评论",
    "发表评论": "发表评论",
    "搜索作品、创作者、文章": "搜索作品、创作者、文章",
    "写文章": "写文章",
    "频道": "频道",
    "项目": "项目",
    "返回编辑": "返回编辑",
    "草稿": "草稿",
    "我的文章": "我的文章",

    "请选中排序创作者": "请选中排序创作者",
    "图片大小至少280 * 280像素，支持JPG、PNG、GIF等格式，图片需小于5M": "图片大小至少280 * 280像素，支持JPG、PNG、GIF等格式，图片需小于5M",
    "图片大小至少2320 * 660像素，支持JPG、PNG、GIF等格式，图片需小于5M": "图片大小至少2320 * 660像素，支持JPG、PNG、GIF等格式，图片需小于5M",
    "英文名称": "英文名称",
    "英文简介": "英文简介",
    "该频道还没有相关活动": "该频道还没有相关活动",
    "还没有成员于此频道发布文章": "还没有成员于此频道发布文章",
    "该频道还没有相关文章": "该频道还没有相关文章",
    "共x个创作者": "共{count}个创作者",
    "共x个成员": "共{count}个成员",
    "共有x个成员于此频道发布文章": "共有{count}个成员于此频道发布文章",
    "共x篇文章": "共{count}篇文章",
    "共x个视频": "共{count}个视频",
    "共x个活动": "共{count}个活动",
    "加载中": "加载中",
    "重新加载": "重新加载",
    "加载出错，请检查网络连接": "加载出错，请检查网络连接",

    "最新排序": "最新排序",
    "热门排序": "热门排序",
    "共x位成员": "共{count}位成员",

    "注": "注",
    "毕业/所在院校": "毕业/所在院校",

    "请填写QQ号": "请填写QQ号",
    "个": "个",
    "请将手机号": "请将手机号",
    "补充完整": "补充完整",
    "请将邮箱": "请将邮箱",
    "请先完善个人资料": "请先完善个人资料",
    "请填写个性签名": "请填写个性签名",
    "请填写个人简介": "请填写个人简介",
    "请上传头像": "请上传头像",
    "请选择性别": "请选择性别",
    "请选择创作领域": "请选择创作领域",
    "该标签已存在": "该标签已存在",
    "通过": "通过",
    "已售罄": "已售罄",
    "售卖中": "售卖中",
    "尚未开始": "尚未开始",
    "暂停售卖": "暂停售卖",
    "新建": "新建",
    "下架": "下架",
    "上架": "上架",
    "其他平台售票": "其他平台售票",
    "其他平台免费报名": "其他平台免费报名",
    "无需报名": "无需报名",
    "开始时间不能大于结束时间": "开始时间不能大于结束时间",
    "确定要将这个票种": "确定要将这个票种",
    "成功": "成功",
    "已取消": "已取消",
    "报名结束时间不可晚于举办结束时间": "报名结束时间不可晚于举办结束时间",
    "请上传视频或选择已发布作品": "请上传视频或选择已发布作品",

    "申请合作": "申请合作",
    "我要发布项目需求": "我要发布项目需求",
    "详细说明": "详细说明",
    "需求截止日期": "需求截止日期",
    "项目预算": "项目预算",
    "项目周期": "项目周期",
    "开始时间": "开始时间",
    "项目阶段": "项目阶段",
    "项目地点": "项目地点",
    "需求方类型": "需求方类型",
    "查看联系方式": "查看联系方式",
    "你尚未认证": "你尚未认证",
    "为保证信息安全": "为保证信息安全",
    "请先进行个人或企业认证": "请先进行个人或企业认证",
    "去认证": "去认证",
    "需求名称": "需求名称",
    "电话": "电话",
    "微信号": "微信号",
    "复制成功": "复制成功",
    "免费": "免费",
    "编辑门票": "编辑门票",
    "售卖结束时间": "售卖结束时间",
    "结束时间": "结束时间",
    "请输入报名": "请输入报名",
    "免费下载": "免费下载",
    "设置 banner": "设置 banner",
    "共": "共",
    "并同意遵守": "并同意遵守",
    "MANA原创/授权视频声明用户规范": "MANA原创/授权视频声明用户规范",
    "《MANA法律责任》": "《MANA法律责任》",
    "请输入举报内容，我们将尽快处理。": "请输入举报内容，我们将尽快处理。",
    "次": "次",
    "活动类型": "活动类型",
    "票种信息": "票种信息",
    "票种名称": "票种名称",
    "数量": "数量",
    "最大购买数量": "最大购买数量",
    "售卖开始时间": "售卖开始时间",
    "售卖截止时间": "售卖截止时间",
    "售卖状态": "售卖状态",
    "暂无数据": "暂无数据",
    "添加免费票": "添加免费票",
    "补充说明": "补充说明",
    "请填写售卖结束时间": "请填写售卖结束时间",
    "请填写售卖开始时间": "请填写售卖开始时间",
    "请填写活动名称": "请填写活动名称",
    "请填写数量": "请填写数量",
    "请填写最大购买数量": "请填写最大购买数量",
    "请选择报名时间": "请选择报名时间",
    "报名时间": "报名时间",
    "请选择举办时间": "请选择举办时间",
    "格式jpeg、png，文件大小≤3MB，图片比例3:4，尺寸≥360*480": "格式jpeg、png，文件大小≤3MB，图片比例3:4，尺寸≥360*480",
    "APP下载": "APP下载",
    "项目对接": "项目对接",
    "招聘": "招聘",
    "发布招聘信息": "发布招聘信息",
    "搜索感兴趣的视频，创作者，活动": "搜索感兴趣的视频，创作者，活动",
    "已经有MANA账户了吗，": "已经有MANA账户了吗，",
    "还没有MANA账户，": "还没有MANA账户，",
    "3G以内": "3G以内",
    "操作": "操作",
    "国 家": "国 家",
    "认 证": "认 证",
    "论坛等": "论坛等",
    "邮   箱": "邮   箱",
    "年/月/日": "年/月/日",
    "即日起至": "即日起至",
    "可多选": "可多选",
    "2019“现未来”科技艺术之星奖组委会": "2019“现未来”科技艺术之星奖组委会",
    "2019“现未来”科技艺术之星奖": "2019“现未来”科技艺术之星奖",
    "手机号登录": "手机号登录",
    "账号密码登录": "账号密码登录",
    "手机号或邮箱": "手机号或邮箱",
    "高校信息": "高校信息",
    "生日": "生日",
    "地址": "地址",
    "性别": "性别",
    "创作领域": "创作领域",
    "社交账户": "社交账户",
    "社交": "社交",
    "个人介绍": "个人介绍",
    "个人/团队介绍": "个人/团队介绍",
    "企业名称": "企业名称",
    "艺术": "艺术",
    "科技": "科技",
    "致力于公共艺术互动装置的设计与新媒体艺术的应用": "致力于公共艺术互动装置的设计与新媒体艺术的应用",
    "账户链接": "账户链接",
    "千核科技": "千核科技",
    "广州": "广州",
    "上海": "上海",
    "武汉": "武汉",
    "微信公众号": "微信公众号",
    "等": "等",
    "分享": "分享",
    "图片截取": "图片截取",
    "对象": "对象",
    "个人信息": "个人信息",
    "地区": "地区",
    "上传图片": "上传图片",
    "是否允许带": "是否允许带",
    "这些": "这些",
    "请求发起前拦截器": "请求发起前拦截器",
    "全局": "全局",
    "状态": "状态",
    "触发": "触发",
    "效果": "效果",
    "请求参数处理成": "请求参数处理成",
    "方法所需的格式": "方法所需的格式",
    "异常处理": "异常处理",
    "响应拦截": "响应拦截",
    "关闭": "关闭",
    "您的账号已在其他地方登录": "您的账号已在其他地方登录",
    "您确定要重新登录吗": "您确定要重新登录吗",
    "确定事件": "确定事件",
    "取消": "取消",
    "取 消": "取 消",
    "删除当前用户登录信息": "删除当前用户登录信息",
    "中文跳英文": "中文跳英文",
    "日期问题": "日期问题",
    "时间戳转时间": "时间戳转时间",
    "去掉所有的": "去掉所有的",
    "标记": "标记",
    "判断是否是": "判断是否是",
    "标签": "标签",
    "跳移动端": "跳移动端",
    "讨论区": "讨论区",
    "视频详情页": "视频详情页",
    "频道详情页": "频道详情页",
    "登陆页面": "登陆页面",
    "认证页面": "认证页面",
    "个人中心": "个人中心",
    "中文版": "中文版",
    "在这里塞入": "在这里塞入",
    "表单": "表单",
    "选中列表": "选中列表",
    "类别列表": "类别列表",
    "是否单选": "是否单选",
    "是否显示全部": "是否显示全部",
    "全部": "全部",
    "全 部": "全部",
    "菜单分类": "菜单分类",
    "关于": "关于",
    "关于我们": "关于我们",
    "用户协议": "用户协议",
    "认证合作艺术家": "认证合作艺术家",
    "免责声明": "免责声明",
    "侵权申诉": "侵权申诉",
    "帮助中心": "帮助中心",
    "吗呐": "吗呐",
    "添加到频道": "添加到频道",
    "推荐到频道": "推荐到频道",
    "还未关注频道": "还未关注频道",
    "还未创建频道": "还未创建频道",
    "确认添加": "确认添加",
    "我创建和我": "我创建和我",
    "加入的": "加入的",
    "我的频道组": "我的频道组",
    "请选择频道": "请选择频道",
    "添加成功": "添加成功",
    "交互": "交互",
    "数字艺术": "数字艺术",
    "视频": "视频",
    "视 频": "视 频",
    "成员": "成员",
    "我关注的": "我关注的",
    "我创建的": "我创建的",
    "取消关注频道后": "取消关注频道后",
    "将收不到频道内任何内容": "将收不到频道内任何内容",
    "取消关注": "取消关注",
    "确定": "确定",
    "确 定": "确 定",
    "删除成功": "删除成功",
    "没有加入的频道": "没有加入的频道",
    "没有创建的频道": "没有创建的频道",
    "修改头像": "修改头像",
    "选择图片": "选择图片",
    "不允许改变已设置的裁图宽高": "不允许改变已设置的裁图宽高",
    "只有自动截图开启": "只有自动截图开启",
    "宽度高度才生效": "宽度高度才生效",
    "文件大小不能小于": "文件大小不能小于",
    "个人主页": "个人主页",
    "我的账户": "我的账户",
    "申请认证": "申请认证",
    "管理视频": "管理视频",
    "播放记录": "播放记录",
    "我的收藏": "我的收藏",
    "我的点赞": "我的点赞",
    "我的关注": "我的关注",
    "我的粉丝": "我的粉丝",
    "我的频道": "我的频道",
    "我的活动": "我的活动",
    "我的竞赛": "我的竞赛",
    "退出登录": "退出登录",
    "只是起到注解作用": "只是起到注解作用",
    "不让文本换行": "不让文本换行",
    "超出的部分显示": "超出的部分显示",
    "报名参加": "报名参加",
    "上传作品": "上传作品",
    "举办方简介": "举办方简介",
    "全球艺术网络科技": "全球艺术网络科技",
    "展开": "展开",
    "时间": "时间",
    "举办时间": "举办时间",
    "频道简介": "频道简介",
    "行业": "行业",
    "行 业": "行 业",
    "专业": "专业",
    "专 业": "专 业",
    "关注该频道": "关注该频道",
    "频道信息": "频道信息",
    "频道内共有": "频道内共有",
    "个视频": "个视频",
    "其中组员推荐的视频有": "其中组员推荐的视频有",
    "设置频道": "设置频道",
    "本频道共有": "本频道共有",
    "个成员": "个成员",
    "收起": "收起",
    "加入成功": "加入成功",
    "进行中": "进行中",
    "至": "至",
    "链接": "链接",
    "线上活动": "线上活动",
    "线下活动": "线下活动",
    "竞赛": "竞赛",
    "全球新媒体艺术平台": "全球新媒体艺术平台",
    "设计": "设计",
    "跨界创新": "跨界创新",
    "登录": "登录",
    "或": "或",
    "注册": "注册",
    "说说你的看法": "说说你的看法",
    "留点足迹": "留点足迹",
    "评论": "评论",
    "全部评论": "全部评论",
    "举报": "举报",
    "请输入回复内容": "请输入回复内容",
    "回复": "回复",
    "查看更多": "查看更多",
    "回复内容不能为空": "回复内容不能为空",
    "回复内容不能超过": "回复内容不能超过",
    "字": "字",
    "暂无其他更多": "暂无其他更多",
    "全部通知": "全部通知",
    "点赞": "点赞",
    "关注": "关注",
    "关 注": "关 注",
    "+关注": "+ 关注",
    "活动": "活动",
    "系统": "系统",
    "下载": "下载",
    "2017年数码艺术奖项“流明艺术”作品征集开启！": "2017年数码艺术奖项“流明艺术”作品征集开启！",
    "数码艺术": "数码艺术",
    "竞赛介绍": "竞赛介绍",
    "全部作品": "全部作品",
    "参赛人员": "参赛人员",
    "我的作品": "我的作品",
    "获奖作品": "获奖作品",
    "关于主办方": "关于主办方",
    "新媒体艺术": "新媒体艺术",
    "创意技术": "创意技术",
    "分类": "分类",
    "腾讯安全": "腾讯安全",
    "艺术影像": "艺术影像",
    "取消收藏": "取消收藏",
    "最新发布": "最新发布",
    "浏览最多": "浏览最多",
    "点赞最多": "点赞最多",
    "成为认证合作艺术家": "成为认证合作艺术家",
    "立即申请": "立即申请",
    "填写报名信息": "填写报名信息",
    "报名参赛须知": "报名参赛须知",
    "姓名": "姓名",
    "必填项": "必填项",
    "年龄": "年龄",
    "手机号": "手机号",
    "用于通知": "用于通知",
    "不会泄露您个人信息": "不会泄露您个人信息",
    "职业": "职业",
    "提交": "提交",
    "提 交": "提 交",
    "广告公关": "广告公关",
    "新闻媒体": "新闻媒体",
    "教育培训": "教育培训",
    "金融投资": "金融投资",
    "建筑业": "建筑业",
    "房地产业": "房地产业",
    "旅游餐饮": "旅游餐饮",
    "学生": "学生",
    "其他": "其他",
    "全球艺术网络科技公司": "全球艺术网络科技公司",
    "公司简介": "公司简介",
    "联系": "联系",
    "作品名称": "作品名称",
    "请输入您的作品名字": "请输入您的作品名字",
    "视频简介": "视频简介",
    "上传参赛视频": "上传参赛视频",
    "上传作品封面": "上传作品封面",
    "为必填内容": "为必填内容",
    "真实姓名": "真实姓名",
    "选择领域": "选择领域",
    "手机号码": "手机号码",
    "常用邮箱": "常用邮箱",
    "在线作品链接": "在线作品链接",
    "可选": "可选",
    "上传您的简历": "上传您的简历",
    "上传简历": "上传简历",
    "文件正在上传": "文件正在上传",
    "提交审核": "提交审核",
    "创建": "创建",
    "已上传": "已上传",
    "文件上传成功": "文件上传成功",
    "奖励": "奖励",
    "元": "元",
    "敬请期待": "敬请期待",
    "通用状态": "通用状态",
    "待审核": "待审核",
    "审核未通过": "审核未通过",
    "已结束": "已结束",
    "保密": "保密",
    "男": "男",
    "女": "女",
    "暂无": "暂无",
    "首页": "首页",
    "发现": "发现",
    "创作者": "创作者",
    "学习": "学习",
    "高校": "高校",
    "搜索": "搜索",
    "上传": "上传",
    "上 传": "上 传",
    "消息": "消息",
    "我的主页": "我的主页",
    "请输入搜索内容": "请输入搜索内容",
    "是否认证": "是否认证",
    "是": "是",
    "否": "否",
    "头像": "头像",
    "作品集": "作品集",
    "动态图像设计": "动态图像设计",
    "用户体验": "用户体验",
    "简介": "简介",
    "最新创作": "最新创作",
    "按浏览量": "按浏览量",
    "按点赞数": "按点赞数",
    "按评论数": "按评论数",
    "视频名称": "视频名称",
    "领域": "领域",
    "左箭头": "左箭头",
    "右箭头": "右箭头",
    "禁用向下箭头": "禁用向下箭头",
    "禁用向上箭头": "禁用向上箭头",
    "粉丝": "粉丝",
    "作品": "作品",
    "请填写举报理由": "请填写举报理由",
    "涉及黄赌毒和暴力": "涉及黄赌毒和暴力",
    "政治": "政治",
    "版权问题": "版权问题",
    "抄袭": "抄袭",
    "也可发邮件给我们": "也可发邮件给我们",
    "执行举报": "执行举报",
    "举报成功": "举报成功",
    "举报失败": "举报失败",
    "姓名不能为空": "姓名不能为空",
    "手机号不能为空": "手机号不能为空",
    "请输入正确的手机号": "请输入正确的手机号",
    "请输入正确的年龄": "请输入正确的年龄",
    "请选择职业": "请选择职业",
    "活动介绍": "活动介绍",
    "报名人员": "报名人员",
    "活动照片": "活动照片",
    "咨询赛事与商务合作，请直接拨打我们的电话或者填写表单，我们将在第一时间响应。": "咨询赛事与商务合作，请直接拨打我们的电话或者填写表单，我们将在第一时间响应。",
    "联系人": "联系人",
    "座机号": "座机号",
    "邮箱": "邮箱",
    "公司名称": "公司名称",
    "请输入公司名称": "请输入公司名称",
    "请输入联系人": "请输入联系人",
    "联系电话": "联系电话",
    "请输入联系电话": "请输入联系电话",
    "电子邮箱": "电子邮箱",
    "请输入电子邮箱": "请输入电子邮箱",
    "详细需求": "详细需求",
    "请输入详细需求": "请输入详细需求",
    "联系人名字": "联系人名字",
    "很抱歉": "很抱歉",
    "你访问的页面不存在": "你访问的页面不存在",
    "输入的地址有误或该地址已被删除": "输入的地址有误或该地址已被删除",
    "返回首页": "返回首页",
    "下一步": "下一步",
    "选择已发布作品": "选择已发布作品",
    "第三方账号绑定": "第三方账号绑定",
    "确认解绑": "确认解绑",
    "暂不解绑": "暂不解绑",
    "申请合并这些账号": "申请合并这些账号",
    "选择发布类型": "选择发布类型",
    "展览": "展览",
    "演出": "演出",
    "展览、演出、论坛等论坛等": "展览、演出、论坛等论坛等",
    "作品征集等": "作品征集等",
    "请选择发布类型": "请选择发布类型",
    "绑定手机号": "绑定手机号",
    "请选择区号": "请选择区号",
    "输入手机号": "输入手机号",
    "验证码": "验证码",
    "获取验证码": "获取验证码",
    "后重新获取": "后重新获取",
    "绑定": "绑定",
    "已绑定成功": "已绑定成功",
    "手机号未被绑定第三方": "手机号未被绑定第三方",
    "这个手机号已经绑定其他账户": "这个手机号已经绑定其他账户",
    "手机号已被绑定第三方": "手机号已被绑定第三方",
    "这个手机号已经绑定其他三方账号": "这个手机号已经绑定其他三方账号",
    "昵称重复": "昵称重复",
    "请修改昵称": "请修改昵称",
    "验证码已发送": "验证码已发送",
    "请输入绑定的账号": "请输入绑定的账号",
    "已选条件": "已选条件",
    "专业类别": "专业类别",
    "认证": "认证",
    "非认证": "非认证",
    "国家": "国家",
    "北京": "北京",
    "深圳": "深圳",
    "列表": "列表",
    "提交作品": "提交作品",
    "导航栏": "导航栏",
    "完善个人资料": "完善个人资料",
    "填写参赛信息": "填写参赛信息",
    "支付费用": "支付费用",
    "国际": "国际",
    "非国际": "非国际",
    "填写竞赛投稿信息": "填写竞赛投稿信息",
    "投稿作品": "投稿作品",
    "编辑": "编辑",
    "作品标题": "作品标题",
    "英文": "英文",
    "作品简介": "作品简介",
    "作品图片": "作品图片",
    "至少上传": "至少上传",
    "删除": "删除",
    "请上传图片": "请上传图片",
    "参赛类别": "参赛类别",
    "请选择参赛类别": "请选择参赛类别",
    "参赛方式": "参赛方式",
    "个人": "个人",
    "团队": "团队",
    "投稿代表同意参赛条款": "投稿代表同意参赛条款",
    "请输入作品标题": "请输入作品标题",
    "请输入作品简介": "请输入作品简介",
    "请选择参赛方式": "请选择参赛方式",
    "参赛条款及细则": "参赛条款及细则",
    "张作品": "张作品",
    "张": "张",
    "投稿成功": "投稿成功",
    "获奖公示": "获奖公示",
    "入围作品": "入围作品",
    "参赛作品": "参赛作品",
    "sumbitWorks": "投稿作品",
    "立即报名": "立即报名",
    "同意并立即报名": "同意并立即报名",
    "不同意": "不同意",
    "投稿中": "投稿中",
    "评审中": "评审中",
    "结束": "结束",
    "近期事件": "近期事件",
    "链接已经失效": "链接已经失效",
    "视频加载中": "视频加载中",
    "请稍后": "请稍后",
    "重置密码": "重置密码",
    "密码": "密码",
    "确认密码": "确认密码",
    "用户服务协议": "用户服务协议",
    "直接登录": "直接登录",
    "两次输入的密码不一致": "两次输入的密码不一致",
    "文件不能大于3G": "文件不能大于3G",
    "标题": "标题",
    "粗体": "粗体",
    "字号": "字号",
    "字体": "字体",
    "斜体": "斜体",
    "下划线": "下划线",
    "文字颜色": "文字颜色",
    "背景颜色": "背景颜色",
    "插入链接": "插入链接",
    "对齐方式": "对齐方式",
    "引用": "引用",
    "表情": "表情",
    "插入图片": "插入图片",
    "插入视频": "插入视频",
    "表格": "表格",
    "撤销": "撤销",
    "重复": "重复",
    "默认": "默认",
    "内容": "内容",
    "左侧菜单栏": "左侧菜单栏",
    "全部院校": "全部院校",
    "获取数据": "获取数据",
    "发布文章": "发布文章",
    "发布问答": "发布问答",
    "发布": "发布",
    "请输入标题": "请输入标题",
    "最多": "最多",
    "个字": "个字",
    "请输入问题": "请输入问题",
    "获取当前问题": "获取当前问题",
    "标题不能为空": "标题不能为空",
    "内容不能为空": "内容不能为空",
    "内容不得少于": "内容不得少于",
    "违禁": "违禁",
    "存在违禁词": "存在违禁词",
    "建议人工复审": "建议人工复审",
    "发布成功": "发布成功",
    "请等待审核": "请等待审核",
    "日程表": "日程表",
    "预售票购买": "预售票购买",
    "论坛介绍": "论坛介绍",
    "本届嘉宾": "本届嘉宾",
    "商务合作": "商务合作",
    "日程表下载": "日程表下载",
    "结果": "结果",
    "频道共有x个": "频道共有<strong>{count}</strong>个",
    "最近更新": "最近更新",
    "按成员数": "按成员数",
    "按视频数": "按视频数",
    "没有匹配的频道": "没有匹配的频道",
    "搜索框内容不能为空": "搜索框内容不能为空",
    "创作者共有x位": "创作者共有<strong>{count}</strong>位",
    "没有匹配的创作者": "没有匹配的创作者",
    "活动共有x个": "活动共有<strong>{count}</strong>个",
    "没有匹配的活动": "没有匹配的活动",
    "模拟": "模拟",
    "键": "键",
    "已关注": "已关注",
    "视频列表": "视频列表",
    "视频数据": "视频数据",
    "监听": "监听",
    "滑动": "滑动",
    "是否取消关注": "是否取消关注",
    "提示": "提示",
    "离开成功": "离开成功",
    "创建比赛": "创建比赛",
    "创建活动": "创建活动",
    "竞赛小助手": "竞赛小助手",
    "现未来": "现未来",
    "报名中": "报名中",
    "编辑活动": "编辑活动",
    "发起活动需要是认证的企业用户": "发起活动需要是认证的企业用户",
    "暂时没有任何活动": "暂时没有任何活动",
    "原手机号": "原手机号",
    "原邮箱": "原邮箱",
    "输入新邮箱地址": "输入新邮箱地址",
    "输入邮箱地址": "输入邮箱地址",
    "输入新的手机号": "输入新的手机号",
    "旧密码": "旧密码",
    "请输入旧密码": "请输入旧密码",
    "新密码": "新密码",
    "手机": "手机",
    "请将原账号补充完整": "请将原账号补充完整",
    "请填写旧密码和新密码": "请填写旧密码和新密码",
    "已经被绑定到账号": "已经被绑定到账号",
    "个账号": "个账号",
    "你可以选择将该": "你可以选择将该",
    "从": "从",
    "个账号中解绑": "个账号中解绑",
    "并绑定到当前账号": "并绑定到当前账号",
    "原账号": "原账号",
    "未绑定任何邮箱和第三方账号": "未绑定任何邮箱和第三方账号",
    "解绑后": "解绑后",
    "将永远无法再登录": "将永远无法再登录",
    "你将无法再通过该手机号登录原账号": "你将无法再通过该手机号登录原账号",
    "未绑定任何手机号和第三方账号": "未绑定任何手机号和第三方账号",
    "你将无法再通过该邮箱登录原账号": "你将无法再通过该邮箱登录原账号",
    "申请创建频道": "申请创建频道",
    "默认排序": "默认排序",
    "联系我们": "联系我们",
    "投稿须知": "投稿须知",
    "常见问题": "常见问题",
    "版权声明": "版权声明",
    "法律责任": "法律责任",
    "内容制作中": "内容制作中",
    "申请创建": "申请创建",
    "报名通道": "报名通道",
    "赛事介绍": "赛事介绍",
    "装置": "装置",
    "投影": "投影",
    "联系方式": "联系方式",
    "赛事概览": "赛事概览",
    "历届获奖作品": "历届获奖作品",
    "奖项设置": "奖项设置",
    "参赛说明": "参赛说明",
    "团队名称或个人姓名": "团队名称或个人姓名",
    "立即验证": "立即验证",
    "邮箱格式不正确": "邮箱格式不正确",
    "请选择": "请选择",
    "手机格式不正确": "手机格式不正确",
    "验证码不正确": "验证码不正确",
    "我已同意": "我已同意",
    "本次大赛参加规则等所有条款": "本次大赛参加规则等所有条款",
    "确认报名": "确认报名",
    "发送验证码": "发送验证码",
    "未选择大赛规则": "未选择大赛规则",
    "请选择国家": "请选择国家",
    "已发送": "已发送",
    "重新获取": "重新获取",
    "个性签名": "个性签名",
    "用户介绍": "用户介绍",
    "排序": "排序",
    "观看更多": "观看更多",
    "评论最多": "评论最多",
    "原创": "原创",
    "非原创": "非原创",
    "条筛选结果": "条筛选结果",
    "作品集和点赞": "作品集和点赞",
    "关注和麻酱": "关注和麻酱",
    "关注状态": "关注状态",
    "加载数据": "加载数据",
    "没有作品集": "没有作品集",
    "没有点赞记录": "没有点赞记录",
    "没有关注记录": "没有关注记录",
    "没有创作者记录": "没有创作者记录",
    "的主页": "的主页",
    "右侧": "右侧",
    "上传头像": "上传头像",
    "设置昵称": "设置昵称",
    "设置新密码": "设置新密码",
    "完成注册": "完成注册",
    "完善资料": "完善资料",
    "设置资料": "设置资料",
    "请输入昵称": "请输入昵称",
    "昵称不能有表情符号等特殊字符": "昵称不能有表情符号等特殊字符",
    "请输入密码": "请输入密码",
    "密码位数不小于7位，不能为纯数字": "密码位数不小于7位，不能为纯数字",
    "密码不少于7位，且不能为纯数字": "密码不少于7位，且不能为纯数字",
    "找回密码": "找回密码",
    "修改昵称": "修改昵称",
    "上传图片大小不能超过": "上传图片大小不能超过",
    "头像更新成功": "头像更新成功",
    "在这里应该返回上一页": "在这里应该返回上一页",
    "请填写昵称": "请填写昵称",
    "注册成功": "注册成功",
    "请完善个人信息": "请完善个人信息",
    "手机号注册": "手机号注册",
    "邮箱注册": "邮箱注册",
    "注册即表示同意": "注册即表示同意",
    "立即登录": "立即登录",
    "立即去注册": "立即去注册",
    "邮箱不能为空": "邮箱不能为空",
    "不是有效的邮箱地址": "不是有效的邮箱地址",
    "密码不能为空": "密码不能为空",
    "验证码不能为空": "验证码不能为空",
    "请输入正确的6位验证码": "请输入正确的6位验证码",
    "已存在该账号": "已存在该账号",
    "请直接登录": "请直接登录",
    "发送失败": "发送失败",
    "该账户已存在": "该账户已存在",
    "三方登录": "三方登录",
    "老账号": "老账号",
    "是否绑定手机号": "是否绑定手机号",
    "已绑定手机号": "已绑定手机号",
    "验证昵称重复否": "验证昵称重复否",
    "不重复": "不重复",
    "修改昵称页面": "修改昵称页面",
    "未绑定手机号": "未绑定手机号",
    "绑定手机号页面": "绑定手机号页面",
    "手机号存在": "手机号存在",
    "手机号已绑定微信": "手机号已绑定微信",
    "绑定失败": "绑定失败",
    "这个手机号已经绑定其他微信用户": "这个手机号已经绑定其他微信用户",
    "手机号未绑定微信": "手机号未绑定微信",
    "创建新账号": "创建新账号",
    "绑定手机": "绑定手机",
    "新用户": "新用户",
    "昵称不重复": "昵称不重复",
    "绑定成功": "绑定成功",
    "微信": "微信",
    "微博": "微博",
    "账号中解绑": "账号中解绑",
    "你将无法再通过该微信登录原账号": "你将无法再通过该微信登录原账号",
    "未绑定任何手机号和邮箱": "未绑定任何手机号和邮箱",
    "邮箱找回": "邮箱找回",
    "手机号找回": "手机号找回",
    "${time}s后可重新获取": "${time}s后可重新获取",
    "该账号不存在": "该账号不存在",
    "频道设置": "频道设置",
    "名称和分类": "名称和分类",
    "简介和背景图": "简介和背景图",
    "设置": "设置",
    "视频管理": "视频管理",
    "活动管理": "活动管理",
    "频道达人": "频道达人",
    "相关频道": "相关频道",
    "基本设置": "基本设置",
    "外观设置": "外观设置",
    "按钮": "按钮",
    "保存设置": "保存设置",
    "返回频道": "返回频道",
    "保存成功": "保存成功",
    "缩略图": "缩略图",
    "选择哪个缩略图代表该频道": "选择哪个缩略图代表该频道",
    "重新选择图片": "重新选择图片",
    "频道内背景大图": "频道内背景大图",
    "您的图片会出现在组顶部": "您的图片会出现在组顶部",
    "这使得你的频道变得独一无二": "这使得你的频道变得独一无二",
    "推荐图片尺寸": "推荐图片尺寸",
    "像素": "像素",
    "最新的缩略图": "最新的缩略图",
    "最近添加视频的缩略图": "最近添加视频的缩略图",
    "自定义上传": "自定义上传",
    "上传自定义缩略图": "上传自定义缩略图",
    "主持团": "主持团",
    "达人": "达人",
    "没有成员": "没有成员",
    "编辑视频": "编辑视频",
    "返回": "返回",
    "按照编号排序": "按照编号排序",
    "编号": "编号",
    "热门": "热门",
    "热 门": "热 门",
    "最新": "最新",
    "文章": "文章",
    "问答": "问答",
    "没有相关的讨论": "没有相关的讨论",
    "搜索本组讨论": "搜索本组讨论",
    "组内成员": "组内成员",
    "加组时间": "加组时间",
    "频道内搜索你想找的成员": "频道内搜索你想找的成员",
    "频道名称": "频道名称",
    "请输入频道名称": "请输入频道名称",
    "请输入频道的简介": "请输入频道的简介",
    "这个是必填栏": "这个是必填栏",
    "创建频道": "创建频道",
    "保存": "保存",
    "创建成功": "创建成功",
    "保存频道": "保存频道",
    "请选择图片上传：大小1160 * 330像素支持JPG、PNG等格式，图片需小于2M": "请选择图片上传：大小1160 * 330像素支持JPG、PNG等格式，图片需小于2M",
    "请选择图片上传：大小1160 * 300像素支持JPG、PNG等格式，图片需小于2M": "请选择图片上传：大小1160 * 300像素支持JPG、PNG等格式，图片需小于2M",
    "请选择图片上传：大小140 * 140像素支持JPG、PNG等格式，图片需小于2M": "请选择图片上传：大小140 * 140像素支持JPG、PNG等格式，图片需小于2M",
    "顺序": "顺序",
    "图片": "图片",
    "图 片": "图 片",
    "创建日期": "创建日期",
    "在线": "在线",
    "下线": "下线",
    "上线": "上线",
    "添加": "添加",
    "重新选择": "重新选择",
    "链接地址": "链接地址",
    "确定删除此banner吗": "确定删除此banner吗",
    "数据": "数据",
    "操作成功": "操作成功",
    "操作成功，请等待审核": "操作成功，请等待审核",
    "操作失败": "操作失败",
    "个频道活动": "个频道活动",
    "初始状态": "初始状态",
    "新增": "新增",
    "编辑状态": "编辑状态",
    "全选": "全选",
    "按序号排序": "按序号排序",
    "活动选择": "活动选择",
    "搜索活动": "搜索活动",
    "已添加": "已添加",
    "已选择": "已选择",
    "个活动": "个活动",
    "非弹窗分页": "非弹窗分页",
    "弹窗分页": "弹窗分页",
    "选择添加一个活动": "选择添加一个活动",
    "确定添加": "确定添加",
    "请选择要添加的活动": "请选择要添加的活动",
    "添加失败": "添加失败",
    "排序成功": "排序成功",
    "请选择要删除的活动": "请选择要删除的活动",
    "删除失败": "删除失败",
    "标签相关": "标签相关",
    "视频共有x部": "视频共有<strong>{count}</strong>部",
    "没有匹配的视频": "没有匹配的视频",
    "热门上传": "热门上传",
    "一天内": "一天内",
    "一周内": "一周内",
    "一月内": "一月内",
    "一年内": "一年内",
    "热门标签": "热门标签",
    "小时前": "小时前",
    "提交成功": "提交成功",
    "点赞成功": "点赞成功",
    "取消点赞成功": "取消点赞成功",
    "评论列表": "评论列表",
    "活动标题": "活动标题",
    "请输入活动标题": "请输入活动标题",
    "活动报名时间": "活动报名时间",
    "活动举办时间": "活动举办时间",
    "购票链接": "购票链接",
    "报名链接": "报名链接",
    "请输入购票链接": "请输入购票链接",
    "活动封面": "活动封面",
    "上传图片请控制在3M以内": "上传图片请控制在3M以内",
    "上传图片比例为": "上传图片比例为",
    "修改": "修改",
    "活动图片": "活动图片",
    "上传图片个数最大为12": "上传图片个数最大为12",
    "活动标题不能为空": "活动标题不能为空",
    "请选择专业": "请选择专业",
    "请选择行业": "请选择行业",
    "请上传图片封面": "请上传图片封面",
    "请输入": "请输入",
    "超出图片上传个数限制": "超出图片上传个数限制",
    "上传图片成功": "上传图片成功",
    "保存后清空内容": "保存后清空内容",
    "请上传活动封面": "请上传活动封面",
    "请上传活动图片": "请上传活动图片",
    "预留分页器": "预留分页器",
    "预留分页接口": "预留分页接口",
    "添加热门": "添加热门",
    "是否原创": "是否原创",
    "获取参数": "获取参数",
    "初始化数据": "初始化数据",
    "15分钟前加组": "15分钟前加组",
    "比赛": "比赛",
    "学校": "学校",
    "投稿活动": "投稿活动",
    "全部活动": "全部活动",
    "江南校友十周年纪念活动": "江南校友十周年纪念活动",
    "江南大学": "江南大学",
    "离开频道组": "离开频道组",
    "审核中": "审核中",
    "离开频道后": "离开频道后",
    "离开频道": "离开频道",
    "已取消删除": "已取消删除",
    "企业号": "企业号",
    "没有关注的创作者": "没有关注的创作者",
    "没有关注的企业号": "没有关注的企业号",
    "官方": "官方",
    "最近播放": "最近播放",
    "清空历史记录": "清空历史记录",
    "没有播放记录": "没有播放记录",
    "确认清空播放记录吗": "确认清空播放记录吗",
    "我的订阅": "我的订阅",
    "订阅的行业": "订阅的行业",
    "讨论区内容": "讨论区内容",
    "审核通过": "审核通过",
    "不通过": "不通过",
    "已删除": "已删除",
    "视频已提交": "视频已提交",
    "请耐心等待审核": "请耐心等待审核",
    "查看视频": "查看视频",
    "推荐竞赛": "推荐竞赛",
    "投稿": "投稿",
    "已审核": "已审核",
    "待编辑": "待编辑",
    "没有相关的视频": "没有相关的视频",
    "确认删除视频吗": "确认删除视频吗",
    "该视频处于大赛中": "该视频处于大赛中",
    "不可删除": "不可删除",
    "不可编辑": "不可编辑",
    "赛事背景": "赛事背景",
    "征集对象": "征集对象",
    "参赛者可以个人或团队名义提交作品": "参赛者可以个人或团队名义提交作品",
    "人工智能": "人工智能",
    "参赛要求": "参赛要求",
    "邮箱及手机": "邮箱及手机",
    "中英文创作者": "中英文创作者",
    "团队介绍": "团队介绍",
    "创作者真实姓名": "创作者真实姓名",
    "参赛时间": "参赛时间",
    "公开征集作品截止日期": "公开征集作品截止日期",
    "北京时间": "北京时间",
    "入围名单公布": "入围名单公布",
    "入围作品将通过赛事官方网站平台公布": "入围作品将通过赛事官方网站平台公布",
    "每项奖金": "每项奖金",
    "奖项说明": "奖项说明",
    "奖杯": "奖杯",
    "证书": "证书",
    "评审团队": "评审团队",
    "创意监制": "创意监制",
    "举办单位": "举办单位",
    "主办方": "主办方",
    "组委会成员": "组委会成员",
    "赞助方": "赞助方",
    "合作方": "合作方",
    "特别支持方": "特别支持方",
    "官方网站": "官方网站",
    "记住我": "记住我",
    "忘记密码": "忘记密码",
    "其他方式": "其他方式",
    "账号不能为空": "账号不能为空",
    "请输入正确的邮箱或手机号": "请输入正确的邮箱或手机号",
    "是不是国外手机号": "是不是国外手机号",
    "密码至少6个字符": "密码至少6个字符",
    "申请加入": "申请加入",
    "热门文章": "热门文章",
    "更多": "更多",
    "问题": "问题",
    "提问": "提问",
    "发表见解": "发表见解",
    "分享知识": "分享知识",
    "精确描述问题": "精确描述问题",
    "得到解答": "得到解答",
    "登陆弹窗": "登陆弹窗",
    "输入账号": "输入账号",
    "输入密码": "输入密码",
    "没有账号": "没有账号",
    "点击注册": "点击注册",
    "第三方登陆": "第三方登陆",
    "请输入账号": "请输入账号",
    "用户名或密码错误": "用户名或密码错误",
    "非本频道成员无法提出问题": "非本频道成员无法提出问题",
    "是否关注此频道继续": "是否关注此频道继续",
    "关注成功": "关注成功",
    "已取消关注": "已取消关注",
    "登陆": "登陆",
    "背景图": "背景图",
    "截图": "截图",
    "成员选择": "成员选择",
    "搜索成员": "搜索成员",
    "个达人": "个达人",
    "请选择要删除的达人": "请选择要删除的达人",
    "请选择要添加的达人": "请选择要添加的达人",
    "达人信息列表": "达人信息列表",
    "个频道": "个频道",
    "弹窗": "弹窗",
    "选择频道": "选择频道",
    "搜索频道": "搜索频道",
    "搜索字段": "搜索字段",
    "请选择要删除的频道": "请选择要删除的频道",
    "请选择要添加的频道": "请选择要添加的频道",
    "添加后刷新": "添加后刷新",
    "行业分类": "行业分类",
    "切换背景图片": "切换背景图片",
    "频道推荐": "频道推荐",
    "每日推荐": "每日推荐",
    "添加至频道": "添加至频道",
    "立刻登录，享受更多功能": "立刻 <a href='/login'>注册/登录</a>，享受更多功能",
    "添加订阅": "添加订阅",
    "活动推荐": "活动推荐",
    "优秀创作者": "优秀创作者",
    "参与的活动": "参与的活动",
    "发起的活动": "发起的活动",
    "没有参与的活动": "没有参与的活动",
    "没有发起的活动": "没有发起的活动",
    "我参加的竞赛": "我参加的竞赛",
    "竞赛名称": "竞赛名称",
    "竞赛状态": "竞赛状态",
    "参赛结果": "参赛结果",
    "去支付": "去支付",
    "退出竞赛": "退出竞赛",
    "没有参与的比赛": "没有参与的比赛",
    "确定退出竞赛": "确定退出竞赛",
    "获奖作品公布": "获奖作品公布",
    "未支付": "未支付",
    "投稿失败": "投稿失败",
    "待支付": "待支付",
    "未入围": "未入围",
    "未获奖": "未获奖",
    "已入围": "已入围",
    "已获奖": "已获奖",
    "没有收藏记录": "没有收藏记录",
    "取消点赞": "取消点赞",
    "以下信息仅用于竞赛，我们将严格保密（个人介绍和所在地除外）": "以下信息仅用于竞赛，我们将严格保密（个人介绍和所在地除外）",
    "请输入真实姓名": "请输入真实姓名",
    "去绑定": "去绑定",
    "如需更换请前往": "如需更换请前往",
    "国籍": "国籍",
    "请选择国籍": "请选择国籍",
    "请输入个人简介": "请输入个人简介",
    "请输入个人/团队简介": "请输入个人/团队简介",
    "所在地": "所在地",
    "请选择省份": "请选择省份",
    "请选择城市": "请选择城市",
    "请输入毕业/所在院校": "请输入毕业/所在院校",
    "已毕业": "已毕业",
    "在读学生": "在读学生",
    "在读": "在读",
    "请输入职业": "请输入职业",
    "职位": "职位",
    "请输入职位": "请输入职位",
    "请先绑定手机号": "请先绑定手机号",
    "请先绑定邮箱": "请先绑定邮箱",
    "最多输入2000个字符": "最多输入2000个字符",
    "最多输入100个字符": "最多输入100个字符",
    "总计": "总计",
    "参赛作品评选费基本费用": "参赛作品评选费基本费用",
    "不包含展示费和得奖者服务费": "不包含展示费和得奖者服务费",
    "支付方式": "支付方式",
    "线下支付": "线下支付",
    "转账请备注": "转账请备注",
    "注册邮箱": "注册邮箱",
    "参赛方": "参赛方",
    "转账人": "转账人",
    "作为报名支付成功的唯一凭证": "作为报名支付成功的唯一凭证",
    "户名": "户名",
    "开户行": "开户行",
    "账号": "账号",
    "外币": "外币",
    "人民币": "人民币",
    "开具发票": "开具发票",
    "普通发票": "普通发票",
    "专用发票": "专用发票",
    "发票抬头": "发票抬头",
    "发票税号": "发票税号",
    "公司地址": "公司地址",
    "公司电话": "公司电话",
    "收件人地址": "收件人地址",
    "收件人电话": "收件人电话",
    "收件人姓名": "收件人姓名",
    "备注": "备注",
    "开票内容为报名费": "开票内容为报名费",
    "发票快递为到付": "发票快递为到付",
    "报名支付如有问题": "报名支付如有问题",
    "请联系": "请联系",
    "恭喜你": "恭喜你",
    "请于3个工作日内完成线下支付": "请于3个工作日内完成线下支付",
    "支付完成审核后即为投稿成功": "支付完成审核后即为投稿成功",
    "请填写发票抬头": "请填写发票抬头",
    "请填写收件人地址": "请填写收件人地址",
    "请填写收件人电话": "请填写收件人电话",
    "请填写收件人姓名": "请填写收件人姓名",
    "请填写发票税号": "请填写发票税号",
    "请填写开户行": "请填写开户行",
    "请填写账号": "请填写账号",
    "请填写公司地址": "请填写公司地址",
    "请填写公司电话": "请填写公司电话",
    "请选择支付方式": "请选择支付方式",
    "用户邮箱": "用户邮箱",
    "订单数量": "订单数量",
    "单价国内": "单价国内",
    "海外": "海外",
    "参赛作品不可在参赛期间自行删除": "参赛作品不可在参赛期间自行删除",
    "如需修改参赛信息": "如需修改参赛信息",
    "可在个人中心": "可在个人中心",
    "我的竞赛下点击": "我的竞赛下点击",
    "进行修改": "进行修改",
    "团队名称": "团队名称",
    "以下设计项目信息默认在成功设计大赛官网公开展示，如不希望公开，可在下方选择不公开": "以下设计项目信息默认在成功设计大赛官网公开展示，如不希望公开，可在下方选择不公开",
    "作品价值": "作品价值",
    "这个作品为用户提供了什么价值": "这个作品为用户提供了什么价值",
    "参考": "参考",
    "这个作品着重在···(功能创新、情感连接、审美、用户体验···)进行了深入地思考，并做了···的尝试/改进/改革": "这个作品着重在···(功能创新、情感连接、审美、用户体验···)进行了深入地思考，并做了···的尝试/改进/改革",
    "请填写中文版": "请填写中文版",
    "请填写英文版": "请填写英文版",
    "不公开": "不公开",
    "商业表现": "商业表现",
    "这个作品在商业上有什么表现": "这个作品在商业上有什么表现",
    "该作品在发布后的···时间内，在（市场销量/占有率，传播价值，品牌知名度···）方面获得了···的成绩": "该作品在发布后的···时间内，在（市场销量/占有率，传播价值，品牌知名度···）方面获得了···的成绩",
    "社会影响": "社会影响",
    "这个作品为社会带来了什么价值": "这个作品为社会带来了什么价值",
    "该作品改变了···的现状/推进了行业向···方向发展/对文化发展起到了···作用/在可持续发展方面发挥了···作用": "该作品改变了···的现状/推进了行业向···方向发展/对文化发展起到了···作用/在可持续发展方面发挥了···作用",
    "团队组织": "团队组织",
    "有哪些人参与了这个作品": "有哪些人参与了这个作品",
    "他们在过程中的角色是": "他们在过程中的角色是",
    "这个作品一共有···位全职成员参与": "这个作品一共有···位全职成员参与",
    "他们分别负责···（设计、结构、策划、市场···）；公司内部/客户方负责···的部门在项 目的···阶段介入给予···的帮助；外部的···（专家、用户、KOL）也在作品的···阶段 介入，担任了···角色": "他们分别负责···（设计、结构、策划、市场···）；公司内部/客户方负责···的部门在项 目的···阶段介入给予···的帮助；外部的···（专家、用户、KOL）也在作品的···阶段 介入，担任了···角色",
    "流程方法": "流程方法",
    "在作品流程中有哪些创新点": "在作品流程中有哪些创新点",
    "这个作品之所以能够达到": "这个作品之所以能够达到",
    "超越预期的目标": "超越预期的目标",
    "是因为流程中我们 在···（流程管理、工具方法、执行过程）方面做了··": "是因为流程中我们 在···（流程管理、工具方法、执行过程）方面做了··",
    "作品投入": "作品投入",
    "该作品从设计到交付，花费了 多少时间？参考：": "该作品从设计到交付，花费了 多少时间？参考：",
    "该作品从立项到设计交付，花费了多少时间？总共 有多少投入？": "该作品从立项到设计交付，花费了多少时间？总共 有多少投入？",
    "达成情况": "达成情况",
    "该作品的目标是什么，结果和预期是否一致？参考：": "该作品的目标是什么，结果和预期是否一致？参考：",
    "做这个作品的初心是为了···，最终的结果 在···方面取得了出乎预料的表现": "做这个作品的初心是为了···，最终的结果 在···方面取得了出乎预料的表现",
    "做这个作品是为了遵循公司的···战略，作品最终对于这个 战略 的推动意义是···": "做这个作品是为了遵循公司的···战略，作品最终对于这个 战略 的推动意义是···",
    "我已同意本次赛事参赛条款及细则": "我已同意本次赛事参赛条款及细则",
    "请填写团队名称": "请填写团队名称",
    "请填写用户价值": "请填写用户价值",
    "请填写英文用户价值": "请填写英文用户价值",
    "请填写商业表现": "请填写商业表现",
    "请填写英文商业表现": "请填写英文商业表现",
    "请填写社会影响": "请填写社会影响",
    "请填写英文社会影响": "请填写英文社会影响",
    "请填写团队组织": "请填写团队组织",
    "请填写英文团队组织": "请填写英文团队组织",
    "请填写流程方法": "请填写流程方法",
    "请填写英文流程方法": "请填写英文流程方法",
    "请填写项目投入": "请填写项目投入",
    "请填写英文项目投入": "请填写英文项目投入",
    "请填写达成情况": "请填写达成情况",
    "请填写英文达成情况": "请填写英文达成情况",
    "请先同意本次赛事参赛条款及细则": "请先同意本次赛事参赛条款及细则",
    "推荐人": "推荐人",
    "视频选择框": "视频选择框",
    "视频选择": "视频选择",
    "搜索视频": "搜索视频",
    "视频审核": "视频审核",
    "获取所有视频": "获取所有视频",
    "请选择要添加的视频": "请选择要添加的视频",
    "选择添加一个视频": "选择添加一个视频",
    "请选择要删除的视频": "请选择要删除的视频",
    "近期热门": "近期热门",
    "分享给朋友": "分享给朋友",
    "分享到新浪微博": "分享到新浪微博",
    "分享到微信": "分享到微信",
    "推荐": "推荐",
    "将视频贴到博客或论坛": "将视频贴到博客或论坛",
    "通用代码": "通用代码",
    "复制": "复制",
    "制作软件": "制作软件",
    "浏览量": "浏览量",
    "其它协作者": "其它协作者",
    "专业比赛": "专业比赛",
    "本作品已参赛": "本作品已参赛",
    "已复制": "已复制",
    "交互设计": "交互设计",
    "装置空间": "装置空间",
    "公共艺术": "公共艺术",
    "专业标签词": "专业标签词",
    "制作软件词": "制作软件词",
    "相关视频": "相关视频",
    "提交商务合作需求": "提交商务合作需求",
    "基本信息": "基本信息",
    "格式": "格式",
    "文件大小": "文件大小",
    "图片比例": "图片比例",
    "尺寸": "尺寸",
    "上传封面": "上传封面",
    "最多选择5个": "最多选择5个",
    "最多选择3个": "最多选择3个",
    "举办地点": "举办地点",
    "选择城市": "选择城市",
    "输入地址": "输入地址",
    "参与方式": "参与方式",
    "门票价格": "门票价格",
    "例如": "例如",
    "报名": "报名",
    "更多设置": "更多设置",
    "选填": "选填",
    "输入标签": "输入标签",
    "参与人员": "参与人员",
    "选填，可以填写艺术家、策展人、主办方等参与人员": "选填，可以填写艺术家、策展人、主办方等参与人员",
    "在活动中的角色": "在活动中的角色",
    "选填，图片不超过3M": "选填，图片不超过3M",
    "活动详情": "活动详情",
    "保存草稿": "保存草稿",
    "购票": "购票",
    "活动标题不能超过40个中文字符": "活动标题不能超过40个中文字符",
    "请选择活动类型": "请选择活动类型",
    "请输入地址": "请输入地址",
    "请输入报名/购票链接": "请输入报名/购票链接",
    "报名/购票链接": "报名/购票链接",
    "国内": "国内",
    "价格": "价格",
    "请填写活动详情": "请填写活动详情",
    "保存草稿成功": "保存草稿成功",
    "编辑频道": "编辑频道",
    "解散频道": "解散频道",
    "头部导航": "头部导航",
    "主页": "主页",
    "收藏": "收藏",
    "发布的讨论": "发布的讨论",
    "查看全部": "查看全部",
    "回复的讨论": "回复的讨论",
    "点赞的讨论": "点赞的讨论",
    "收藏的讨论": "收藏的讨论",
    "来自": "来自",
    "的讨论区": "的讨论区",
    "问答详情": "问答详情",
    "写下你的回复": "写下你的回复",
    "是否确定删除": "是否确定删除",
    "返回到上个页面": "返回到上个页面",
    "您没有权限删除": "您没有权限删除",
    "回复成功": "回复成功",
    "请等待人工审核": "请等待人工审核",
    "个人认证": "个人认证",
    "企业认证": "企业认证",
    "你的个人认证信息已审核通过": "你的个人认证信息已审核通过",
    "恭喜你成为我们尊贵的个人认证会员": "恭喜你成为我们尊贵的个人认证会员",
    "个人认证信息审核中": "个人认证信息审核中",
    "你的企业认证信息已审核通过": "你的企业认证信息已审核通过",
    "恭喜你成为我们尊贵的企业认证会员": "恭喜你成为我们尊贵的企业认证会员",
    "信息认证": "信息认证",
    "必填": "必填",
    "请输入姓名": "请输入姓名",
    "身份证": "身份证",
    "位身份证号码": "位身份证号码",
    "请选择地区": "请选择地区",
    "请输入城市": "请输入城市",
    "请输入手机号": "请输入手机号",
    "请输入验证码": "请输入验证码",
    "上传证件照": "上传证件照",
    "上传证件照正面": "上传证件照正面",
    "点击上传": "点击上传",
    "上传证件照反面": "上传证件照反面",
    "证件要求": "证件要求",
    "需上传本人露脸手持二代身份证照片＋身份证反面照片（不需手持）": "需上传本人露脸手持二代身份证照片＋身份证反面照片（不需手持）",
    "身份证反面照片": "身份证反面照片",
    "证件必须在有效期内，有效期需在一个月以上": "证件必须在有效期内，有效期需在一个月以上",
    "照片要求": "照片要求",
    "文字清晰可辨": "文字清晰可辨",
    "证件照上信息需完整且清晰可辨（无反光、遮挡、水印、证件套、logo等）": "证件照上信息需完整且清晰可辨（无反光、遮挡、水印、证件套、logo等）",
    "遮挡": "遮挡",
    "水印": "水印",
    "申请人填写的“公司名称”需和提交证件照片信息一致": "申请人填写的“公司名称”需和提交证件照片信息一致",
    "证件必须真实拍摄，不能使用复印件，不能对镜（证件信息反转）拍摄": "证件必须真实拍摄，不能使用复印件，不能对镜（证件信息反转）拍摄",
    "拍摄": "拍摄",
    "确保照片完整": "确保照片完整",
    "确保照片完整（不缺边角），证件周围不允许加上边角框（如：加上红框等）": "确保照片完整（不缺边角），证件周围不允许加上边角框（如：加上红框等）",
    "提交认证": "提交认证",
    "企业认证信息审核中": "企业认证信息审核中",
    "企业信息": "企业信息",
    "企业信用代码": "企业信用代码",
    "请输入企业信用代码": "请输入企业信用代码",
    "需上传企业工商营业执照": "需上传企业工商营业执照",
    "组织机构代码证照": "组织机构代码证照",
    "商标注册证或商标注册受理通知书": "商标注册证或商标注册受理通知书",
    "组织机构代码证上传证件照": "组织机构代码证上传证件照",
    "工商营业执照上传证件照": "工商营业执照上传证件照",
    "营业执照照片或扫描件": "营业执照照片或扫描件",
    "请输入身份证号码": "请输入身份证号码",
    "身份证格式不正确": "身份证格式不正确",
    "请输入所在城市": "请输入所在城市",
    "手机号格式不正确": "手机号格式不正确",
    "请上传": "请上传",
    "以内的图片": "以内的图片",
    "请上传证件照正面": "请上传证件照正面",
    "请上传证件照反面": "请上传证件照反面",
    "手机号已修改": "手机号已修改",
    "请重新获取验证码": "请重新获取验证码",
    "请上传执照": "请上传执照",
    "重新发送": "重新发送",
    "上传视频": "上传视频",
    "支持格式": "支持格式",
    "文件大小限制": "文件大小限制",
    "上传视频，即表示您已同意MANA上传服务条款，请勿上传色情，反动等违法视频": "上传视频，即表示您已同意MANA上传服务条款，请勿上传色情，反动等违法视频",
    "并同意遵守《MANA原创/授权视频声明用户规范》、《MANA法律责任》": "并同意遵守《MANA原创/授权视频声明用户规范》、《MANA法律责任》",
    "帮助说明": "帮助说明",
    "视频正在上传": "视频正在上传",
    "视频基本信息": "视频基本信息",
    "请输入作品名字": "请输入作品名字",
    "作品类型": "作品类型",
    "原创标签需要": "原创标签需要",
    "后进行设置": "后进行设置",
    "其他创作者": "其他创作者",
    "请上传作品封面": "请上传作品封面",
    "添加标签": "添加标签",
    "添加标签可以把作品自动推荐给可能感兴趣的人": "添加标签可以把作品自动推荐给可能感兴趣的人",
    "作品标签": "作品标签",
    "空格或回车添加作品标签": "空格或回车添加作品标签",
    "请输入标签": "请输入标签",
    "贴标签": "贴标签",
    "选择行业和专业": "选择行业和专业",
    "可以把作品自动归类到对应的行业和专业": "可以把作品自动归类到对应的行业和专业",
    "更多信息设置": "更多信息设置",
    "作品是否允许被下载": "作品是否允许被下载",
    "请输入装备标签": "请输入装备标签",
    "投稿至比赛": "投稿至比赛",
    "不投稿": "不投稿",
    "预览": "预览",
    "记得改为": "记得改为",
    "标签内容不能为空": "标签内容不能为空",
    "标签内容不能重复": "标签内容不能重复",
    "标签个数超过上限": "标签个数超过上限",
    "不可重复添加": "不可重复添加",
    "请先进行个人认证": "请先进行个人认证",
    "上传失败": "上传失败",
    "上传成功": "上传成功",
    "视频正在转码中": "视频正在转码中",
    "视频上传成功": "视频上传成功",
    "验证": "验证",
    "视频名称不能为空": "视频名称不能为空",
    "请选择是否原创": "请选择是否原创",
    "视频简介不能为空": "视频简介不能为空",
    "请上传作品图片": "请上传作品图片",
    "请选择是否允许被下载": "请选择是否允许被下载",
    "查看全部简介": "查看全部简介",
    "相关活动": "相关活动",
    "热门活动": "热门活动",
    "讨论区域": "讨论区域",
    "右侧区域": "右侧区域",
    "没有相关的活动": "没有相关的活动",
    "频道公告": "频道公告",
    "去看看": "去看看",
    "第三方登录": "第三方登录",
    "删除多余": "删除多余",
    "文本编辑器": "文本编辑器",
    "登陆方式": "登陆方式",
    "个人资料": "个人资料",
    "账号安全": "账号安全",
    "仅自己可见": "仅自己可见",
    "昵称": "昵称",
    "请填写真实姓名": "请填写真实姓名",
    "选择日期": "选择日期",
    "请输入个性签名": "请输入个性签名",
    "个人简介": "个人简介",
    "请输入个人介绍": "请输入个人介绍",
    "教育背景": "教育背景",
    "学校名称": "学校名称",
    "请输入院校": "请输入院校",
    "请填写微信号": "请填写微信号",
    "所有人": "所有人",
    "请填写": "请填写",
    "个人链接": "个人链接",
    "个人网站": "个人网站",
    "新浪微博": "新浪微博",
    "密码修改": "密码修改",
    "账号信息": "账号信息",
    "未绑定": "未绑定",
    "登录密码": "登录密码",
    "解绑": "解绑",
    "邮箱修改": "邮箱修改",
    "创作领域最多只能选三个": "创作领域最多只能选三个",
    "确定解绑": "确定解绑",
    "解绑成功": "解绑成功",
    "已取消解绑": "已取消解绑",
    "修改手机号": "修改手机号",
    "修改邮箱": "修改邮箱",
    "绑定邮箱": "绑定邮箱",
    "修改密码": "修改密码",
    "请输入联系地址": "请输入联系地址",
    "个人介绍不能超过2000字": "个人介绍不能超过2000字",
    "输入框不能为空": "输入框不能为空",
    "个性签名不能超过": "个性签名不能超过",
    "用户信息保存": "用户信息保存",
    "仅校验必填字段": "仅校验必填字段",
    "个人简介不能超过": "个人简介不能超过",
    "请填写创作领域": "请填写创作领域",
    "请选择所在地": "请选择所在地",
    "链接保存": "链接保存",
    "请按规范填写以下信息": "请按规范填写以下信息",
    "邮件发送成功": "邮件发送成功",
    "请及时查看邮件": "请及时查看邮件",
    "头像上传": "头像上传",
    "新增保存创作领域": "新增保存创作领域",
    "视频上传": "视频上传",
    "正在上传": "正在上传",
    "重新上传": "重新上传",
    "视频封面": "视频封面",
    "视频封面随机图": "视频封面随机图",
    "系统默认可选封面": "系统默认可选封面",
    "视频标题": "视频标题",
    "类型": "类型",
    "类 型": "类 型",
    "上下拖拽可调整排序": "上下拖拽可调整排序",
    "在作品中的角色": "在作品中的角色",
    "选择共同创作者": "选择共同创作者",
    "选择标签": "选择标签",
    "其他标签": "其他标签",
    "填写丰富的标签有助于增加作品的曝光": "填写丰富的标签有助于增加作品的曝光",
    "其他设置": "其他设置",
    "开放下载": "开放下载",
    "请仔细考虑是否愿意开放给所有": "请仔细考虑是否愿意开放给所有",
    "注册用户": "注册用户",
    "进行免费下载": "进行免费下载",
    "下载的视频将会带有": "下载的视频将会带有",
    "和": "和",
    "您的": "您的",
    "这将有利于您的作品在网络传播": "这将有利于您的作品在网络传播",
    "被更多人看见": "被更多人看见",
    "查看示例": "查看示例",
    "不开放": "不开放",
    "开放": "开放",
    "当前用户": "当前用户",
    "其他工作设置": "其他工作设置",
    "专业最多只能选": "专业最多只能选",
    "行业最多只能选": "行业最多只能选",
    "共同创作者已存在": "共同创作者已存在",
    "保存其它行业和专业": "保存其它行业和专业",
    "新增行业不能为空": "新增行业不能为空",
    "新增专业不能为空": "新增专业不能为空",
    "新增其他标签不能为空": "新增其他标签不能为空",
    "新增工作设置不能为空": "新增工作设置不能为空",
    "新增成功": "新增成功",
    "添加行业标签": "添加行业标签",
    "为选中状态": "为选中状态",
    "清空当前变量": "清空当前变量",
    "隐藏保存": "隐藏保存",
    "请检查上传格式是否符合支持格式": "请检查上传格式是否符合支持格式",
    "默认截取封面图": "默认截取封面图",
    "第一帧": "第一帧",
    "随机": "随机",
    "帧": "帧",
    "获取时长": "获取时长",
    "随机两个图片": "随机两个图片",
    "视频名称英文不能为空": "视频名称英文不能为空",
    "视频简介英文不能为空": "视频简介英文不能为空",
    "其他标签处理": "其他标签处理",
    "添加新增数据": "添加新增数据",
    "缩列图": "缩列图",
    "处理": "处理",
    "选择已发布的作品": "选择已发布的作品",
    "开始日期": "开始日期",
    "结束日期": "结束日期",
    "MANA平台报名": "MANA平台报名",
    "最大购买数量不可小于0,且不可大于总票数": "最大购买数量不可小于0,且不可大于总票数",
    "温馨提示：请谨慎判断并注意交易安全": "温馨提示：请谨慎判断并注意交易安全",
    "10M以内": "10M以内",
    "付费课程": "付费课程",
    "直播": "直播",
    "免费课程": "免费课程",
    "人已购买": "人已购买",
    "人感兴趣": "人感兴趣",
    "学院": "学院",
    "请输入标题和正文": "请输入标题和正文",
    "帮助手册": "帮助手册",
    "隐私政策": "隐私政策",
    "线上线下活动详情": "线上线下活动详情",
    "活动报名": "活动报名",
    "比赛报名": "比赛报名",
    "下载页": "下载页",
    "用户中心": "用户中心",
    "我的嘛酱": "我的嘛酱",
    "我的比赛": "我的比赛",
    "消息中心": "消息中心",
    "2019“现未来”科技艺术之星奖-竞赛介绍": "2019“现未来”科技艺术之星奖-竞赛介绍",
    "2019“现未来”科技艺术之星奖-获奖公示": "2019“现未来”科技艺术之星奖-获奖公示",
    "2019“现未来”科技艺术之星奖-入围作品": "2019“现未来”科技艺术之星奖-入围作品",
    "2019“现未来”科技艺术之星奖-参赛作品": "2019“现未来”科技艺术之星奖-参赛作品",
    "竞赛首页": "竞赛首页",
    "视频嵌入页": "视频嵌入页",
    "上海设计周先锋论坛": "date 上海设计周先锋论坛",
    "上传比赛视频": "上传比赛视频",
    "发现视频": "发现视频",
    "发现创作者": "发现创作者",
    "文章列表": "文章列表",
    "邮箱认证": "邮箱认证",
    "搜索页": "搜索页",
    "发起活动-竞赛": "发起活动-竞赛",
    "授权": "授权",
    "页面未找到": "页面未找到",
    "发现频道": "发现频道",
    "赛事资讯": "赛事资讯",
    "景观设计": "景观设计",
    "动态设计": "动态设计",
    "热门推荐": "热门推荐",
}



// WEBPACK FOOTER //
// ./src/languages/cn/global.js